mutation ResetStreamKey($contentId: ID!) {
  resetStreamKey(contentId: $contentId) {
    id
    stream {
      id
      rtmpsUrl
      rtmpsStreamKey
      srtUrl
      srtStreamId
      srtPassphrase
    }
  }
}
